import * as React from 'react';
import styled from 'styled-components';

interface Props {
  children?: any;
}

export class HrefText extends React.Component<Props> {
  constructor(props) {
    super(props);
  }

  public render() {
    return <HrefTextStyle> {this.props.children} </HrefTextStyle>;
  }
}

const HrefTextStyle = styled.div`
  font-size: ${({ theme }) => theme.fontSizeXS};
  font-family: ${({ theme }) => theme.primaryFont};
  color: ${({ theme }) => theme.secondaryFontColor};
  text-decoration: underline;
`;
